/**
 * Created by Ivan on 03.01.2025
 */

const BonusLevelView = cc.Node.extend({
    ctor: function (bonusLevelCounter, timeLeft) {
        this._super();

        const chestHorizontal = this.chestHorizontal = new BonusLevelChest({ timeLeft });
        this.addChild(chestHorizontal, -1);
        cleverapps.aims.registerTarget("bonus_chest", chestHorizontal.chest);

        const chestVertical = this.chestVertical = new BonusLevelChest({ timeLeft, isVertical: true });
        this.addChild(chestVertical, -1);
        cleverapps.aims.registerTarget("bonus_chest_vertical", chestVertical.chest);

        this.onResize();

        bonusLevelCounter.on("onCollect", this.openChest.bind(this), this);
    },

    getOverlappingNodes: function () {
        return cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL ? this.chestHorizontal : this.chestVertical;
    },

    openChest: function (amount) {
        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            this.chestHorizontal.open(amount);
        } else {
            this.chestVertical.open(amount);
        }
    },

    onResize: function () {
        this.setContentSize2(cleverapps.resolution.getSceneSize());
        this.setAlignment(cleverapps.styles.BonusLevelView);
    },

    // The chest keeps clear of the menubar and the moves view, so it waits for them to stand in place.
    onAfterResize: function () {
        const styles = cleverapps.styles.BonusLevelView;

        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            this.chestHorizontal.show(styles.horizontal);
            this.chestVertical.hide();
        } else {
            this.chestHorizontal.hide();
            this.chestVertical.show(styles.vertical);
        }
    },

    hide: function (callback) {
        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            this.chestHorizontal.remove(callback);
        } else {
            this.chestVertical.remove(callback);
        }
    }
});

BonusLevelView.getTarget = function () {
    return cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL ? "bonus_chest" : "bonus_chest_vertical";
};

cleverapps.styles.BonusLevelView = {
    x: { align: "center", dx: 0 },
    y: { align: "center", dy: 0 },

    horizontal: {
        x: { align: "right", dx: -220 },
        y: { align: "bottom", dy: -50 }
    },

    vertical: [
        { x: { align: "center", dx: 0 }, y: { align: "top", dy: -50 } },
        { x: { align: "center", dx: 0 }, y: { align: "top", dy: -100 } },
        { x: { align: "center", dx: 0 }, y: { align: "top", dy: -150 } },
        { x: { align: "center", dx: 0 }, y: { align: "top", dy: -250 } }
    ]
};